export default __webpack_public_path__ + "static/media/mobile.aa3e0ce4.svg";